import { register } from "async-ops";
import { callMvcApi } from "../../../../call-web-api";
import mdaeNotfy, { NOTIFY_MESSAGE_TYPE } from "../../../../common_components/common_widgets/toast/notify";
import { getDefaultOptions } from "../../../../utils/fetch";
export const DELETE_EXTERNAL_AUDIT_CASE = "DELETE_EXTERNAL_AUDIT_CASE";

export const service = async (data) => {
  const options: object = {
    url: `/Api/EaCaseBillingApiController/DeleteExternalAuditCase`,
    method: "POST",
    body: JSON.stringify(data),
    ...getDefaultOptions(),
  };

  const response = await callMvcApi(options);
  if (response.isDeleted) {
    mdaeNotfy({ message: "Case Deleted Succesfully!", messageType: NOTIFY_MESSAGE_TYPE.SUCCESS })
  }
  else{
    mdaeNotfy({ message: response, messageType: NOTIFY_MESSAGE_TYPE.ERROR })
  }
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(DELETE_EXTERNAL_AUDIT_CASE, service, mock);
